import React from 'react';
import { PropTypes } from 'prop-types';
import get from 'lodash/get';
import Skeleton from 'Common/Components/Skeleton';
import Text from './styled';

const hasValue = (value) => value !== undefined && value !== null && value !== '';

const getCellLabel = (rowInfo, attrib, defVal) => {
  const label = get(rowInfo, `original.${attrib}`, defVal);
  if (attrib !== 'obj_id' || hasValue(label)) return label;
  return get(rowInfo, 'original.id', get(rowInfo, 'original._id', defVal));
};

// eslint-disable-next-line import/prefer-default-export
export const GenericCell = ({
  rowInfo, attrib, defVal, capitalize, showSkeleton
}) => {
  const label = getCellLabel(rowInfo, attrib, defVal);
  if (showSkeleton) return <Skeleton />;
  return (
    <Text capitalize={ capitalize }>
      { label }
    </Text>
  );
};

GenericCell.propTypes = {
  rowInfo: PropTypes.object.isRequired,
  attrib: PropTypes.string.isRequired,
  defVal: PropTypes.string,
  capitalize: PropTypes.bool,
  showSkeleton: PropTypes.bool
};

GenericCell.defaultProps = {
  defVal: '',
  capitalize: false,
  showSkeleton: false
};
